import { Component } from '@angular/core';
import { theme } from '../../../data/theme';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    theme = theme;
    links = [
        {'title': 'About Us', 'url': '/about-us'},
        {'title': 'Privacy Policy', 'url' : '/privacy-policy'},
        {'title': 'Terms And Conditions', 'url' : '/terms-and-conditions'},
        {'title': 'Contact Us', 'url' : '/contact-us'},
    ]
    constructor() { }
}
